import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentsFilterService {

  constructor(private httpProvider: HttpProviderService) { }


  fetchBeneList(): Observable<any> {
    const httpRequest: HttpRequestPayload = {
      resource: '/beneficiary',
      method: "GET",

    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
      return response.body;
    },
      catchError((err: IHttpErrorPayload) => {
        return throwError(err)
      })));
  }
}